<template>
  <section class="view">
    <section class="view snowflakes" aria-hidden="true">
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <h1 class="title solmas flash">Solmas</h1>
      <p class="ca">UNbT74tbUhtPM8YWmBTbWk9JxbAeNQCQP89jjWnpump</p>
      <img class="logo width" src="../assets/solomas-transp.png" />
      <section class="socials-section">
        <a
          href="https://open.spotify.com/album/6mxWJLgWM8YFoHjI4dYIQV"
          target="BLANK"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill-rule="evenodd"
            class="socials hide2"
            clip-rule="evenodd"
            fill="white"
            viewBox="0 0 24 24"
          >
            <path
              d="M19.098 10.638c-3.868-2.297-10.248-2.508-13.941-1.387-.593.18-1.22-.155-1.399-.748-.18-.593.154-1.22.748-1.4 4.239-1.287 11.285-1.038 15.738 1.605.533.317.708 1.005.392 1.538-.316.533-1.005.709-1.538.392zm-.126 3.403c-.272.44-.847.578-1.287.308-3.225-1.982-8.142-2.557-11.958-1.399-.494.15-1.017-.129-1.167-.623-.149-.495.13-1.016.624-1.167 4.358-1.322 9.776-.682 13.48 1.595.44.27.578.847.308 1.286zm-1.469 3.267c-.215.354-.676.465-1.028.249-2.818-1.722-6.365-2.111-10.542-1.157-.402.092-.803-.16-.895-.562-.092-.403.159-.804.562-.896 4.571-1.045 8.492-.595 11.655 1.338.353.215.464.676.248 1.028zm-5.503-17.308c-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12z"
            />
          </svg>
        </a>

        <a href="https://x.com/solmascto" target="BLANK">
          <svg
            viewBox="0 0 24 24"
            aria-label="X"
            role="img"
            class="socials"
            fill="white"
          >
            <g>
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
              ></path>
            </g>
          </svg>
        </a>
        <a
          href="https://dexscreener.com/solana/bhceyicmpsw8wmi2rfd1c13s6xbaojvezt1yncyrrwhp"
          target="BLANK"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            fill="white"
            fill-rule="evenodd"
            viewBox="0 0 252 300"
            focusable="false"
            class="socials"
          >
            <path
              d="M151.818 106.866c9.177-4.576 20.854-11.312 32.545-20.541 2.465 5.119 2.735 9.586 1.465 13.193-.9 2.542-2.596 4.753-4.826 6.512-2.415 1.901-5.431 3.285-8.765 4.033-6.326 1.425-13.712.593-20.419-3.197m1.591 46.886l12.148 7.017c-24.804 13.902-31.547 39.716-39.557 64.859-8.009-25.143-14.753-50.957-39.556-64.859l12.148-7.017a5.95 5.95 0 003.84-5.845c-1.113-23.547 5.245-33.96 13.821-40.498 3.076-2.342 6.434-3.518 9.747-3.518s6.671 1.176 9.748 3.518c8.576 6.538 14.934 16.951 13.821 40.498a5.95 5.95 0 003.84 5.845zM126 0c14.042.377 28.119 3.103 40.336 8.406 8.46 3.677 16.354 8.534 23.502 14.342 3.228 2.622 5.886 5.155 8.814 8.071 7.897.273 19.438-8.5 24.796-16.709-9.221 30.23-51.299 65.929-80.43 79.589-.012-.005-.02-.012-.029-.018-5.228-3.992-11.108-5.988-16.989-5.988s-11.76 1.996-16.988 5.988c-.009.005-.017.014-.029.018-29.132-13.66-71.209-49.359-80.43-79.589 5.357 8.209 16.898 16.982 24.795 16.709 2.929-2.915 5.587-5.449 8.814-8.071C69.31 16.94 77.204 12.083 85.664 8.406 97.882 3.103 111.959.377 126 0m-25.818 106.866c-9.176-4.576-20.854-11.312-32.544-20.541-2.465 5.119-2.735 9.586-1.466 13.193.901 2.542 2.597 4.753 4.826 6.512 2.416 1.901 5.432 3.285 8.766 4.033 6.326 1.425 13.711.593 20.418-3.197"
            ></path>
            <path
              d="M197.167 75.016c6.436-6.495 12.107-13.684 16.667-20.099l2.316 4.359c7.456 14.917 11.33 29.774 11.33 46.494l-.016 26.532.14 13.754c.54 33.766 7.846 67.929 24.396 99.193l-34.627-27.922-24.501 39.759-25.74-24.231L126 299.604l-41.132-66.748-25.739 24.231-24.501-39.759L0 245.25c16.55-31.264 23.856-65.427 24.397-99.193l.14-13.754-.016-26.532c0-16.721 3.873-31.578 11.331-46.494l2.315-4.359c4.56 6.415 10.23 13.603 16.667 20.099l-2.01 4.175c-3.905 8.109-5.198 17.176-2.156 25.799 1.961 5.554 5.54 10.317 10.154 13.953 4.48 3.531 9.782 5.911 15.333 7.161 3.616.814 7.3 1.149 10.96 1.035-.854 4.841-1.227 9.862-1.251 14.978L53.2 160.984l25.206 14.129a41.926 41.926 0 015.734 3.869c20.781 18.658 33.275 73.855 41.861 100.816 8.587-26.961 21.08-82.158 41.862-100.816a41.865 41.865 0 015.734-3.869l25.206-14.129-32.665-18.866c-.024-5.116-.397-10.137-1.251-14.978 3.66.114 7.344-.221 10.96-1.035 5.551-1.25 10.854-3.63 15.333-7.161 4.613-3.636 8.193-8.399 10.153-13.953 3.043-8.623 1.749-17.689-2.155-25.799l-2.01-4.175z"
            ></path>
          </svg>
        </a>
        <a href="https://www.tiktok.com/@solmascto" target="BLANK">
          <svg
            class="socials tiktok"
            viewBox="0 0 48 48"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g fill-rule="evenodd">
              <path
                d="M38.0766847,15.8542954 C36.0693906,15.7935177 34.2504839,14.8341149 32.8791434,13.5466056 C32.1316475,12.8317108 31.540171,11.9694126 31.1415066,11.0151329 C30.7426093,10.0603874 30.5453728,9.03391952 30.5619062,8 L24.9731521,8 L24.9731521,28.8295196 C24.9731521,32.3434487 22.8773693,34.4182737 20.2765028,34.4182737 C19.6505623,34.4320127 19.0283477,34.3209362 18.4461858,34.0908659 C17.8640239,33.8612612 17.3337909,33.5175528 16.8862248,33.0797671 C16.4386588,32.6422142 16.0833071,32.1196657 15.8404292,31.5426268 C15.5977841,30.9658208 15.4727358,30.3459348 15.4727358,29.7202272 C15.4727358,29.0940539 15.5977841,28.4746337 15.8404292,27.8978277 C16.0833071,27.3207888 16.4386588,26.7980074 16.8862248,26.3604545 C17.3337909,25.9229017 17.8640239,25.5791933 18.4461858,25.3491229 C19.0283477,25.1192854 19.6505623,25.0084418 20.2765028,25.0219479 C20.7939283,25.0263724 21.3069293,25.1167239 21.794781,25.2902081 L21.794781,19.5985278 C21.2957518,19.4900128 20.7869423,19.436221 20.2765028,19.4380839 C18.2431278,19.4392483 16.2560928,20.0426009 14.5659604,21.1729264 C12.875828,22.303019 11.5587449,23.9090873 10.7814424,25.7878401 C10.003907,27.666593 9.80084889,29.7339663 10.1981162,31.7275214 C10.5953834,33.7217752 11.5748126,35.5530237 13.0129853,36.9904978 C14.4509252,38.4277391 16.2828722,39.4064696 18.277126,39.8028054 C20.2711469,40.1991413 22.3382874,39.9951517 24.2163416,39.2169177 C26.0948616,38.4384508 27.7002312,37.1209021 28.8296253,35.4300711 C29.9592522,33.7397058 30.5619062,31.7522051 30.5619062,29.7188301 L30.5619062,18.8324027 C32.7275484,20.3418321 35.3149087,21.0404263 38.0766847,21.0867664 L38.0766847,15.8542954 Z"
                fill="white"
              ></path>
            </g>
          </svg>
        </a>
        <a href="https://t.me/solmascto" target="BLANK">
          <svg
            fill="white"
            class="socials hide2"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.122 10.040c0.006-0 0.014-0 0.022-0 0.209 0 0.403 0.065 0.562 0.177l-0.003-0.002c0.116 0.101 0.194 0.243 0.213 0.403l0 0.003c0.020 0.122 0.031 0.262 0.031 0.405 0 0.065-0.002 0.129-0.007 0.193l0-0.009c-0.225 2.369-1.201 8.114-1.697 10.766-0.21 1.123-0.623 1.499-1.023 1.535-0.869 0.081-1.529-0.574-2.371-1.126-1.318-0.865-2.063-1.403-3.342-2.246-1.479-0.973-0.52-1.51 0.322-2.384 0.221-0.23 4.052-3.715 4.127-4.031 0.004-0.019 0.006-0.040 0.006-0.062 0-0.078-0.029-0.149-0.076-0.203l0 0c-0.052-0.034-0.117-0.053-0.185-0.053-0.045 0-0.088 0.009-0.128 0.024l0.002-0.001q-0.198 0.045-6.316 4.174c-0.445 0.351-1.007 0.573-1.619 0.599l-0.006 0c-0.867-0.105-1.654-0.298-2.401-0.573l0.074 0.024c-0.938-0.306-1.683-0.467-1.619-0.985q0.051-0.404 1.114-0.827 6.548-2.853 8.733-3.761c1.607-0.853 3.47-1.555 5.429-2.010l0.157-0.031zM15.93 1.025c-8.302 0.020-15.025 6.755-15.025 15.060 0 8.317 6.742 15.060 15.060 15.060s15.060-6.742 15.060-15.060c0-8.305-6.723-15.040-15.023-15.060h-0.002q-0.035-0-0.070 0z"
            ></path>
          </svg>
        </a>
      </section>
    </section>
    <a href="https://phantom.com/tokens/solana/UNbT74tbUhtPM8YWmBTbWk9JxbAeNQCQP89jjWnpump" target="BLANK">
        <button class="buy-button">BUY $SOLMAS</button>
      </a>

    <section class="socials-section hide">
      <a
        href="https://open.spotify.com/album/6mxWJLgWM8YFoHjI4dYIQV"
        target="BLANK"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          class="socials"
          clip-rule="evenodd"
          fill="white"
          viewBox="0 0 24 24"
        >
          <path
            d="M19.098 10.638c-3.868-2.297-10.248-2.508-13.941-1.387-.593.18-1.22-.155-1.399-.748-.18-.593.154-1.22.748-1.4 4.239-1.287 11.285-1.038 15.738 1.605.533.317.708 1.005.392 1.538-.316.533-1.005.709-1.538.392zm-.126 3.403c-.272.44-.847.578-1.287.308-3.225-1.982-8.142-2.557-11.958-1.399-.494.15-1.017-.129-1.167-.623-.149-.495.13-1.016.624-1.167 4.358-1.322 9.776-.682 13.48 1.595.44.27.578.847.308 1.286zm-1.469 3.267c-.215.354-.676.465-1.028.249-2.818-1.722-6.365-2.111-10.542-1.157-.402.092-.803-.16-.895-.562-.092-.403.159-.804.562-.896 4.571-1.045 8.492-.595 11.655 1.338.353.215.464.676.248 1.028zm-5.503-17.308c-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12z"
          />
        </svg>
      </a>
      <a href="https://t.me/solmascto" target="BLANK">
        <svg
          fill="white"
          class="socials"
          viewBox="0 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.122 10.040c0.006-0 0.014-0 0.022-0 0.209 0 0.403 0.065 0.562 0.177l-0.003-0.002c0.116 0.101 0.194 0.243 0.213 0.403l0 0.003c0.020 0.122 0.031 0.262 0.031 0.405 0 0.065-0.002 0.129-0.007 0.193l0-0.009c-0.225 2.369-1.201 8.114-1.697 10.766-0.21 1.123-0.623 1.499-1.023 1.535-0.869 0.081-1.529-0.574-2.371-1.126-1.318-0.865-2.063-1.403-3.342-2.246-1.479-0.973-0.52-1.51 0.322-2.384 0.221-0.23 4.052-3.715 4.127-4.031 0.004-0.019 0.006-0.040 0.006-0.062 0-0.078-0.029-0.149-0.076-0.203l0 0c-0.052-0.034-0.117-0.053-0.185-0.053-0.045 0-0.088 0.009-0.128 0.024l0.002-0.001q-0.198 0.045-6.316 4.174c-0.445 0.351-1.007 0.573-1.619 0.599l-0.006 0c-0.867-0.105-1.654-0.298-2.401-0.573l0.074 0.024c-0.938-0.306-1.683-0.467-1.619-0.985q0.051-0.404 1.114-0.827 6.548-2.853 8.733-3.761c1.607-0.853 3.47-1.555 5.429-2.010l0.157-0.031zM15.93 1.025c-8.302 0.020-15.025 6.755-15.025 15.060 0 8.317 6.742 15.060 15.060 15.060s15.060-6.742 15.060-15.060c0-8.305-6.723-15.040-15.023-15.060h-0.002q-0.035-0-0.070 0z"
          ></path>
        </svg>
      </a>
    </section>

    <section class="about-section">
      <ul class="lightrope">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <h1 class="title flash2">ABOUT US</h1>
      <p class="text">
        🎄Celebrate Christmas all year round with $SOLMAS!🎄
      </p>
        <p class="text">  In the early hours of its creation, the
        dev rugged our token but the community rallied together to rebuild it!
        We have relaunched the Telegram group, website, and X account.  The community has created a trending TikTok packed with hilarious memes and we even have our own AI generated music
        album listed on Spotify! (It's very catchy!)</p>
        <p class="text">
        $SOLMAS is all about fun, laughter, and spreading Christmas
        cheer. Join our community and have a #MERRYSOLMAS! 🎁✨
      </p>
    </section>
    <section class="roadmap-section">
      <ul class="lightrope">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <h1 class="title flash roadmap-title">ROADMAP</h1>
      <p class="text">
        🎄 The community’s vision is clear 🎄
        </p>
        <p class="text"> $SOLMAS will be THE TOP Christmas token
        of the Solana blockchain!
      </p>
        <p class="text">
        To make this happen, we’ve allocated funds
        to secure raiders and various trending boosts every single day leading up to and including
        Christmas!  Let’s spread the cheer and make $SOLMAS shine! 🎁✨
      </p>
    </section>
    <section class="about-section">
      <ul class="lightrope">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <h1 class="title flash2">TOKENOMICS</h1>
      <section class="checkbox-section">
        <div class="checkbox">
          <img src="../assets/cane-checkmark.png" class="check" />
          <p class="text">100% LP Burned</p>
        </div>
        <div class="checkbox">
          <img src="../assets/cane-checkmark.png" class="check" />
          <p class="text">0% Taxes</p>
        </div>
        <div class="checkbox">
          <img src="../assets/cane-checkmark.png" class="check" />
          <p class="text">Contract Renounced</p>
        </div>
        <div class="checkbox">
          <img src="../assets/cane-checkmark.png" class="check" />
          <p class="text">1B Supply</p>
        </div>
      </section>
    </section>
    <section class="meme-section">
      <ul class="lightrope">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <h1 class="title flash">MEMES</h1>
      <img class="meme width" src="../assets/meme1.png" />
      <img class="meme width" src="../assets/meme2.png" />
      <img class="meme width" src="../assets/meme4.png" />
      <img class="meme width" src="../assets/meme7.png" />
     
    </section>
    <!-- <div class="container">
  <svg class="svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="350" height="400">
    <path fill="transparent" d="M0 0h350v400H0z"/>
    <g fill="#CCE6F4" class="cloud">
      <path d="M63 53h65a13 13 0 0113 13 13 13 0 01-13 13H61a12 12 0 01-12-12 14 14 0 0114-14z"/>
      <path d="M83 26a19 19 0 0119 19v1a19 19 0 01-19 19h-2a18 18 0 01-18-18v-1a20 20 0 0120-20z"/>
      <path d="M113 38a14 14 0 0114 14v1a14 14 0 01-14 14h-2a13 13 0 01-13-13v-1a15 15 0 0115-15z"/>
    </g>
    <g fill="#CCE6F4" class="cloud">
      <path d="M202.936 343.907h52.943a10.589 10.589 0 0110.588 10.589 10.589 10.589 0 01-10.588 10.588h-54.572a9.774 9.774 0 01-9.774-9.774 11.403 11.403 0 0111.403-11.403z"/>
      <path d="M219.226 321.916a15.476 15.476 0 0115.476 15.475v.815a15.476 15.476 0 01-15.476 15.475h-1.629a14.661 14.661 0 01-14.661-14.66v-.815a16.29 16.29 0 0116.29-16.29z"/>
      <path d="M243.661 331.69a11.403 11.403 0 0111.403 11.403v.814a11.403 11.403 0 01-11.403 11.403h-1.629a10.589 10.589 0 01-10.588-10.588v-.815a12.218 12.218 0 0112.217-12.217z"/>
    </g>
    <g fill="#CCE6F4" class="cloud">
      <path d="M12.936 245.907h52.943a10.589 10.589 0 0110.588 10.589 10.589 10.589 0 01-10.588 10.588H11.307a9.774 9.774 0 01-9.774-9.774 11.403 11.403 0 0111.403-11.403z"/>
      <path d="M29.226 223.916a15.476 15.476 0 0115.476 15.475v.815a15.476 15.476 0 01-15.476 15.475h-1.629a14.661 14.661 0 01-14.661-14.66v-.815a16.29 16.29 0 0116.29-16.29z"/>
      <path d="M53.661 233.69a11.403 11.403 0 0111.403 11.403v.814a11.403 11.403 0 01-11.403 11.403h-1.629a10.589 10.589 0 01-10.588-10.588v-.815A12.218 12.218 0 0153.66 233.69z"/>
    </g>
    <g fill="#CCE6F4" class="cloud">
      <path d="M246.79835,143.07881h75.40328a15.04912,15.04912,0,0,1,15.04912,15.04912v0a15.0491,15.0491,0,0,1-15.0491,15.0491H244.79837a14.04912,14.04912,0,0,1-14.04912-14.04912v0A16.0491,16.0491,0,0,1,246.79835,143.07881Z"/>
      <path d="M269.00509,111.82294h2.04917a21.04912,21.04912,0,0,1,21.04912,21.04912v3.04917a21.04909,21.04909,0,0,1-21.04909,21.04909h-4.04917A20.04912,20.04912,0,0,1,246.956,136.9212V133.872a22.04909,22.04909,0,0,1,22.04909-22.04909Z" />
      <path d="M304.522,125.71444h.47291A16.04912,16.04912,0,0,1,321.044,141.76356v1.47291a16.0491,16.0491,0,0,1-16.0491,16.0491H302.522a15.04912,15.04912,0,0,1-15.04912-15.04912v-1.47291A17.0491,17.0491,0,0,1,304.522,125.71444Z"/>
    </g>
    <g class="plane">
      <rect x="215.747" y="157.738" width="25.511" height="43.645" rx="12.755" ry="12.755" fill="rgb(15, 50, 10)"/>
      <path fill="green" d="M166.263 185.401h74.995v31.965h-74.995zM166.263 217.366h74.995a31.965 31.965 0 01-31.965 31.965h-43.03v-31.965z"/>
      <g class="hand">
        <rect x="136.437" y="152.836" width="26.365" height="9.113" rx="4.557" ry="4.557" transform="rotate(-120 149.62 157.393)" fill="#f6bfb1"/>
        <path fill="rgb(15, 50, 10)" d="M144.906 163.746l11.978-6.916 20.407 35.346-11.978 6.916z"/>
        <rect x="139.226" y="154.214" width="20.172" height="6.973" rx="3.486" ry="3.486" transform="rotate(-30 149.312 157.7)" fill="#e6e6e6"/>
      </g>
      <path fill="#f6bfb1" d="M171.488 155.28h37.805v23.974h-37.805z"/>
      <path d="M165.956 185.093v64.545h-12.602v-.024c-.406.015-.818.024-1.23.024a32.272 32.272 0 110-64.545c.412 0 .824.01 1.23.025v-.025z" fill="rgb(15, 50, 10)"/>
      <path fill="darkgreen" d="M161.345 185.093h4.918v64.545h-4.918z"/>
      <path d="M113.376 210.296v11.987h-2.34v-.004a6.053 6.053 0 01-.23.004 5.993 5.993 0 110-11.987c.077 0 .154.002.23.005v-.005z" fill="rgb(15, 50, 10)"/>
      <g fill="green">
        <circle cx="155.505" cy="244.106" r="2.459"/>
        <circle cx="155.505" cy="190.933" r="2.459"/>
        <circle cx="155.505" cy="208.452" r="2.459"/>
        <circle cx="155.505" cy="226.586" r="2.459"/>
      </g>
      <rect class="blade" x="113.244" y="167.266" width="6.762" height="98.354" rx="3.381" ry="3.381" fill="rgb(15, 50, 10)"/>
      <path d="M195.154 211.526h34.732a4.918 4.918 0 014.917 4.918 4.918 4.918 0 01-4.917 4.917h-34.732a4.918 4.918 0 01-4.917-4.917 4.918 4.918 0 014.917-4.918z" fill="darkgreen"/>
      <g fill="#fff">
        <rect x="174.148" y="171.282" width="15.925" height="40.192" rx="7.963" ry="7.963"/>
        <rect x="188.824" y="171.282" width="15.925" height="40.192" rx="7.963" ry="7.963"/>
        <rect x="180.862" y="167.691" width="15.925" height="51.21" rx="7.963" ry="7.963" transform="rotate(-90 188.824 193.296)"/>
        <path d="M161.55 180.896a7.963 7.963 0 016.42-9.252l20.066-3.625a7.963 7.963 0 019.251 6.42 7.963 7.963 0 01-6.42 9.251l-20.066 3.626a7.963 7.963 0 01-9.251-6.42z"/>
        <path d="M183.122 174.543a7.963 7.963 0 019.251-6.42l19.491 3.521a7.963 7.963 0 016.42 9.252 7.963 7.963 0 01-9.251 6.42l-19.491-3.522a7.963 7.963 0 01-6.42-9.25z"/>
      </g>
      <rect x="167.185" y="151.899" width="6.455" height="27.355" rx="3.227" ry="3.227" fill="rgb(15, 50, 10)"/>
      <rect x="207.449" y="151.899" width="6.455" height="27.355" rx="3.227" ry="3.227" fill="rgb(15, 50, 10)"/>
      <circle cx="190.083" cy="165.883" r="3.842" fill="#e76160"/>
      <circle cx="190.083" cy="179.868" r="6.454"/>
      <path fill="rgb(15, 50, 10)" d="M167.185 148.21h46.718v7.069h-46.718zM213.903 145.137h-46.718a10.757 10.757 0 0110.757-10.758h25.204a10.757 10.757 0 0110.757 10.758z"/>
      <path fill="#711723" d="M167.185 143.907h46.718v4.303h-46.718z"/>
      <circle cx="181.016" cy="146.059" r="7.377" fill="#711723"/>
      <circle cx="181.016" cy="146.059" r="5.62" fill="#300403"/>
      <circle cx="200.072" cy="146.059" r="7.377" fill="#711723"/>
      <circle cx="200.072" cy="146.059" r="5.62" fill="#300403"/>
      <path d="M176.713 165.422s2.459-3.995 6.454 0M197.306 165.422s2.459-3.995 6.454 0" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="1.844"/>
    </g>
  </svg>    
</div> -->
    <div class="container">
      <svg
        class="svg"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="350"
        height="400"
      >
        <path fill="transparent" d="M0 0h350v400H0z" />
        <g fill="#CCE6F4" class="cloud">
          <path
            d="M63 53h65a13 13 0 0113 13 13 13 0 01-13 13H61a12 12 0 01-12-12 14 14 0 0114-14z"
          />
          <path
            d="M83 26a19 19 0 0119 19v1a19 19 0 01-19 19h-2a18 18 0 01-18-18v-1a20 20 0 0120-20z"
          />
          <path
            d="M113 38a14 14 0 0114 14v1a14 14 0 01-14 14h-2a13 13 0 01-13-13v-1a15 15 0 0115-15z"
          />
        </g>
        <g fill="#CCE6F4" class="cloud">
          <path
            d="M202.936 343.907h52.943a10.589 10.589 0 0110.588 10.589 10.589 10.589 0 01-10.588 10.588h-54.572a9.774 9.774 0 01-9.774-9.774 11.403 11.403 0 0111.403-11.403z"
          />
          <path
            d="M219.226 321.916a15.476 15.476 0 0115.476 15.475v.815a15.476 15.476 0 01-15.476 15.475h-1.629a14.661 14.661 0 01-14.661-14.66v-.815a16.29 16.29 0 0116.29-16.29z"
          />
          <path
            d="M243.661 331.69a11.403 11.403 0 0111.403 11.403v.814a11.403 11.403 0 01-11.403 11.403h-1.629a10.589 10.589 0 01-10.588-10.588v-.815a12.218 12.218 0 0112.217-12.217z"
          />
        </g>
        <g fill="#CCE6F4" class="cloud">
          <path
            d="M12.936 245.907h52.943a10.589 10.589 0 0110.588 10.589 10.589 10.589 0 01-10.588 10.588H11.307a9.774 9.774 0 01-9.774-9.774 11.403 11.403 0 0111.403-11.403z"
          />
          <path
            d="M29.226 223.916a15.476 15.476 0 0115.476 15.475v.815a15.476 15.476 0 01-15.476 15.475h-1.629a14.661 14.661 0 01-14.661-14.66v-.815a16.29 16.29 0 0116.29-16.29z"
          />
          <path
            d="M53.661 233.69a11.403 11.403 0 0111.403 11.403v.814a11.403 11.403 0 01-11.403 11.403h-1.629a10.589 10.589 0 01-10.588-10.588v-.815A12.218 12.218 0 0153.66 233.69z"
          />
        </g>
        <g fill="#CCE6F4" class="cloud">
          <path
            d="M246.79835,143.07881h75.40328a15.04912,15.04912,0,0,1,15.04912,15.04912v0a15.0491,15.0491,0,0,1-15.0491,15.0491H244.79837a14.04912,14.04912,0,0,1-14.04912-14.04912v0A16.0491,16.0491,0,0,1,246.79835,143.07881Z"
          />
          <path
            d="M269.00509,111.82294h2.04917a21.04912,21.04912,0,0,1,21.04912,21.04912v3.04917a21.04909,21.04909,0,0,1-21.04909,21.04909h-4.04917A20.04912,20.04912,0,0,1,246.956,136.9212V133.872a22.04909,22.04909,0,0,1,22.04909-22.04909Z"
          />
          <path
            d="M304.522,125.71444h.47291A16.04912,16.04912,0,0,1,321.044,141.76356v1.47291a16.0491,16.0491,0,0,1-16.0491,16.0491H302.522a15.04912,15.04912,0,0,1-15.04912-15.04912v-1.47291A17.0491,17.0491,0,0,1,304.522,125.71444Z"
          />
        </g>
        <g class="plane">
          <rect
            x="215.747"
            y="157.738"
            width="25.511"
            height="43.645"
            rx="12.755"
            ry="12.755"
            fill="#711723"
          />
          <path
            fill="#f40009"
            d="M166.263 185.401h74.995v31.965h-74.995zM166.263 217.366h74.995a31.965 31.965 0 01-31.965 31.965h-43.03v-31.965z"
          />
          <g class="hand">
            <rect
              x="136.437"
              y="152.836"
              width="26.365"
              height="9.113"
              rx="4.557"
              ry="4.557"
              transform="rotate(-120 149.62 157.393)"
              fill="#f6bfb1"
            />
            <path
              fill="#f40009"
              d="M144.906 163.746l11.978-6.916 20.407 35.346-11.978 6.916z"
            />
            <rect
              x="139.226"
              y="154.214"
              width="20.172"
              height="6.973"
              rx="3.486"
              ry="3.486"
              transform="rotate(-30 149.312 157.7)"
              fill="#e6e6e6"
            />
          </g>
          <path fill="#f6bfb1" d="M171.488 155.28h37.805v23.974h-37.805z" />
          <path
            d="M165.956 185.093v64.545h-12.602v-.024c-.406.015-.818.024-1.23.024a32.272 32.272 0 110-64.545c.412 0 .824.01 1.23.025v-.025z"
            fill="#711723"
          />
          <path fill="#300403" d="M161.345 185.093h4.918v64.545h-4.918z" />
          <path
            d="M113.376 210.296v11.987h-2.34v-.004a6.053 6.053 0 01-.23.004 5.993 5.993 0 110-11.987c.077 0 .154.002.23.005v-.005z"
            fill="#f40009"
          />
          <g fill="#300403">
            <circle cx="155.505" cy="244.106" r="2.459" />
            <circle cx="155.505" cy="190.933" r="2.459" />
            <circle cx="155.505" cy="208.452" r="2.459" />
            <circle cx="155.505" cy="226.586" r="2.459" />
          </g>
          <rect
            class="blade"
            x="113.244"
            y="167.266"
            width="6.762"
            height="98.354"
            rx="3.381"
            ry="3.381"
            fill="#300403"
          />
          <path
            d="M195.154 211.526h34.732a4.918 4.918 0 014.917 4.918 4.918 4.918 0 01-4.917 4.917h-34.732a4.918 4.918 0 01-4.917-4.917 4.918 4.918 0 014.917-4.918z"
            fill="#711723"
          />
          <g fill="#fff">
            <rect
              x="174.148"
              y="171.282"
              width="15.925"
              height="40.192"
              rx="7.963"
              ry="7.963"
            />
            <rect
              x="188.824"
              y="171.282"
              width="15.925"
              height="40.192"
              rx="7.963"
              ry="7.963"
            />
            <rect
              x="180.862"
              y="167.691"
              width="15.925"
              height="51.21"
              rx="7.963"
              ry="7.963"
              transform="rotate(-90 188.824 193.296)"
            />
            <path
              d="M161.55 180.896a7.963 7.963 0 016.42-9.252l20.066-3.625a7.963 7.963 0 019.251 6.42 7.963 7.963 0 01-6.42 9.251l-20.066 3.626a7.963 7.963 0 01-9.251-6.42z"
            />
            <path
              d="M183.122 174.543a7.963 7.963 0 019.251-6.42l19.491 3.521a7.963 7.963 0 016.42 9.252 7.963 7.963 0 01-9.251 6.42l-19.491-3.522a7.963 7.963 0 01-6.42-9.25z"
            />
          </g>
          <rect
            x="167.185"
            y="151.899"
            width="6.455"
            height="27.355"
            rx="3.227"
            ry="3.227"
            fill="#711723"
          />
          <rect
            x="207.449"
            y="151.899"
            width="6.455"
            height="27.355"
            rx="3.227"
            ry="3.227"
            fill="#711723"
          />
          <circle cx="190.083" cy="165.883" r="3.842" fill="#e76160" />
          <circle cx="190.083" cy="179.868" r="6.454" />
          <path
            fill="#f40009"
            d="M167.185 148.21h46.718v7.069h-46.718zM213.903 145.137h-46.718a10.757 10.757 0 0110.757-10.758h25.204a10.757 10.757 0 0110.757 10.758z"
          />
          <path fill="#711723" d="M167.185 143.907h46.718v4.303h-46.718z" />
          <circle cx="181.016" cy="146.059" r="7.377" fill="#711723" />
          <circle cx="181.016" cy="146.059" r="5.62" fill="#300403" />
          <circle cx="200.072" cy="146.059" r="7.377" fill="#711723" />
          <circle cx="200.072" cy="146.059" r="5.62" fill="#300403" />
          <path
            d="M176.713 165.422s2.459-3.995 6.454 0M197.306 165.422s2.459-3.995 6.454 0"
            fill="none"
            stroke="#000"
            stroke-miterlimit="10"
            stroke-width="1.844"
          />
        </g>
      </svg>
    </div>
    <section class="about-section">
      <ul class="lightrope">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <h1 class="title flash2">HOW TO BUY</h1>
      <p class="text">1. DOWNLOAD PHANTOM WALLET</p>
      <p class="text">2. GET SOLANA IN YOUR WALLET</p>
      <p class="text">3. BUY $SOLMAS!</p>
      <a href="https://phantom.com/tokens/solana/UNbT74tbUhtPM8YWmBTbWk9JxbAeNQCQP89jjWnpump" target="BLANK">
        <button class="buy-button">BUY $SOLMAS</button>
      </a>
      
    </section>
    <section class="disclaimer-section">
      <ul class="lightrope">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>

      <p class="text" style="padding-top: 40px">
        <span style="color: red">Legal Disclaimer: </span> $SOLMAS is a meme
        coin with no intrinsic value or expectation of financial return. $SOLMAS
        is for entertainment purposes only. When you purchase $SOLMAS, you are
        agreeing that you have seen this disclaimer.
      </p>
    </section>
  </section>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<style scoped>
@font-face {
    font-family: RetroGaming;
    src: url('~@/assets/RetroGaming.ttf');
}

.buy-button {
  background-color: rgb(15, 50, 10);
  padding: 10px 30px 10px 30px;
  font-size: 40px;
  font-family:  "RetroGaming", sans-serif;
  color: white;
  border-radius: 15px;
  box-shadow: 3px 3px 30px white;
  margin: 35px;
  margin-top : 10px;
  border: 5px white solid;
}

.buy-button:hover {
  color: red;
}

.checkbox-section {
  margin-bottom: 30px;
}

.checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.check {
  width: 50px;
}

.container {
  height: 480px;
  width: 350px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  top: 97.5%;
  left: 50%;
}
.svg {
  position: absolute;
  top: 0;
  left: 0;
}
.plane {
  position: relative;
  -webkit-animation: float 3s infinite;
  animation: float 3s infinite;
}
@-webkit-keyframes float {
  50% {
    -webkit-transform: translateY(25px);
    transform: translateY(25px);
  }
}
@keyframes float {
  50% {
    -webkit-transform: translateY(25px);
    transform: translateY(25px);
  }
}
.hand {
  -webkit-transform: rotate(10deg);
  -ms-transform: rotate(10deg);
  transform: rotate(10deg);
  -webkit-animation: wave 1.5s infinite;
  animation: wave 1.5s infinite;
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
}
.blade {
  -webkit-animation: spin 1s infinite linear;
  animation: spin 1s infinite linear;
  -webkit-transform-origin: 50% 54%;
  -ms-transform-origin: 50% 54%;
  transform-origin: 50% 54%;
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotateX(360deg);
    transform: rotateX(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotateX(360deg);
    transform: rotateX(360deg);
  }
}
@-webkit-keyframes wave {
  50% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
}
@keyframes wave {
  50% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
}
@media screen and (min-width: 451px) {
  a {
    font-size: 20px;
    padding: 8px 12px 8px 12px;
  }
}

@media screen and (max-width: 450px) {
  a {
    font-size: 14px;
    padding: 5px 8px 5px 8px;
  }
}

.lightrope {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  margin: -15px 0 0 0;
  padding: 0;
  pointer-events: none;
  width: 100%;
}
.lightrope li {
  position: relative;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  list-style: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 12px;
  height: 28px;
  border-radius: 50%;
  margin: 20px;
  display: inline-block;
  background: #00f7a5;
  box-shadow: 0px 4.6666666667px 24px 3px #00f7a5;
  animation-name: flash-1;
  animation-duration: 2s;
}
.lightrope li:nth-child(2n + 1) {
  background: cyan;
  box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 255, 255, 0.5);
  animation-name: flash-2;
  animation-duration: 0.4s;
}
.lightrope li:nth-child(4n + 2) {
  background: #f70094;
  box-shadow: 0px 4.6666666667px 24px 3px #f70094;
  animation-name: flash-3;
  animation-duration: 1.1s;
}
.lightrope li:nth-child(odd) {
  animation-duration: 1.8s;
}
.lightrope li:nth-child(3n + 1) {
  animation-duration: 1.4s;
}
.lightrope li:before {
  content: "";
  position: absolute;
  background: #222;
  width: 10px;
  height: 9.3333333333px;
  border-radius: 3px;
  top: -4.6666666667px;
  left: 1px;
}
.lightrope li:after {
  content: "";
  top: -14px;
  left: 9px;
  position: absolute;
  width: 52px;
  height: 18.6666666667px;
  border-bottom: solid #222 2px;
  border-radius: 50%;
}
.lightrope li:last-child:after {
  content: none;
}
.lightrope li:first-child {
  margin-left: -40px;
}
@keyframes flash-1 {
  0%,
  100% {
    background: #00f7a5;
    box-shadow: 0px 4.6666666667px 24px 3px #00f7a5;
  }
  50% {
    background: rgba(0, 247, 165, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 247, 165, 0.2);
  }
}
@keyframes flash-2 {
  0%,
  100% {
    background: cyan;
    box-shadow: 0px 4.6666666667px 24px 3px cyan;
  }
  50% {
    background: rgba(0, 255, 255, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 255, 255, 0.2);
  }
}
@keyframes flash-3 {
  0%,
  100% {
    background: #f70094;
    box-shadow: 0px 4.6666666667px 24px 3px #f70094;
  }
  50% {
    background: rgba(247, 0, 148, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(247, 0, 148, 0.2);
  }
}

.text {
  width: 80%;
  margin-bottom: 40px;
}

.about-section {
  background-color: red;
  border-top: 5px ridge white;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.disclaimer-section {
  background-color: rgb(15, 50, 10);
  border-top: 5px ridge white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 400px;
  width: 100;
}

.roadmap-section {
  background-color: rgb(15, 50, 10);
  border-top: 5px ridge white;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100;
}

.snowflake {
  color: #fff;
  font-size: 1.5em;
  font-family: Arial;
  text-shadow: 0 0 1px #000;
}

@-webkit-keyframes snowflakes-fall {
  0% {
    top: -10%;
  }
  100% {
    top: 100%;
  }
}
@-webkit-keyframes snowflakes-shake {
  0% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
  50% {
    -webkit-transform: translateX(80px);
    transform: translateX(80px);
  }
  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}
@keyframes snowflakes-fall {
  0% {
    top: -10%;
  }
  100% {
    top: 100%;
  }
}
@keyframes snowflakes-shake {
  0% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(80px);
  }
  100% {
    transform: translateX(0px);
  }
}
.snowflake {
  position: fixed;
  top: -10%;
  z-index: 9999;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
  -webkit-animation-name: snowflakes-fall, snowflakes-shake;
  -webkit-animation-duration: 10s, 3s;
  -webkit-animation-timing-function: linear, ease-in-out;
  -webkit-animation-iteration-count: infinite, infinite;
  -webkit-animation-play-state: running, running;
  animation-name: snowflakes-fall, snowflakes-shake;
  animation-duration: 10s, 3s;
  animation-timing-function: linear, ease-in-out;
  animation-iteration-count: infinite, infinite;
  animation-play-state: running, running;
}
.snowflake:nth-of-type(0) {
  left: 1%;
  -webkit-animation-delay: 0s, 0s;
  animation-delay: 0s, 0s;
}
.snowflake:nth-of-type(1) {
  left: 10%;
  -webkit-animation-delay: 1s, 1s;
  animation-delay: 1s, 1s;
}
.snowflake:nth-of-type(2) {
  left: 20%;
  -webkit-animation-delay: 6s, 0.5s;
  animation-delay: 6s, 0.5s;
}
.snowflake:nth-of-type(3) {
  left: 30%;
  -webkit-animation-delay: 4s, 2s;
  animation-delay: 4s, 2s;
}
.snowflake:nth-of-type(4) {
  left: 40%;
  -webkit-animation-delay: 2s, 2s;
  animation-delay: 2s, 2s;
}
.snowflake:nth-of-type(5) {
  left: 50%;
  -webkit-animation-delay: 8s, 3s;
  animation-delay: 8s, 3s;
}
.snowflake:nth-of-type(6) {
  left: 60%;
  -webkit-animation-delay: 6s, 2s;
  animation-delay: 6s, 2s;
}
.snowflake:nth-of-type(7) {
  left: 70%;
  -webkit-animation-delay: 2.5s, 1s;
  animation-delay: 2.5s, 1s;
}
.snowflake:nth-of-type(8) {
  left: 80%;
  -webkit-animation-delay: 1s, 0s;
  animation-delay: 1s, 0s;
}
.snowflake:nth-of-type(9) {
  left: 90%;
  -webkit-animation-delay: 3s, 1.5s;
  animation-delay: 3s, 1.5s;
}

.flash {
  animation: flash-animation 1.5s infinite;
}

.flash2 {
  animation: flash-animation2 1.5s infinite;
}

@keyframes flash-animation2 {
  0% {
    color: rgb(15, 50, 10);
  }
  50% {
    color: white;
  }
  100% {
    color: rgb(15, 50, 10);
  }
}

@keyframes flash-animation {
  0% {
    color: red;
  }
  50% {
    color: white;
  }
  100% {
    color: red;
  }
}

.title {
  font-size: 30px;
  margin-top: 0px;
  color: white;
  margin-bottom: 0px;
}

.socials {
  width: 50px;
}

.tiktok {
  width: 65px;
}

.socials-section {
  display: flex;
  flex-direction: row;
  gap: 10%;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}

.socials:hover {
  fill: rgb(230, 0, 3);
}

.ca:hover {
  color: rgb(230, 0, 3);
}

.ca {
  font-size: 5px;
}

.width {
  width: 60%;
  max-width: 800px;
}

.view {
  background-image: url("../assets/pixel-christmas.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  min-height: min-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.meme {
  padding: 0em;
  border: 5px solid transparent;
  border-image: 16
    repeating-linear-gradient(
      -45deg,
      red 0,
      red 1em,
      transparent 0,
      transparent 2em,
      white,
      white 3em,
      transparent 0,
      transparent 4em
    );

  max-width: 25em;
  font: 100%/1.6 Baskerville, Palatino, serif;
  box-shadow: 3px 3px 30px white;
  margin-bottom: 15%;
  margin: 15px;
}

p {
  color: white;
}

.meme-section {
  background-color: rgb(15, 50, 10);
  border-top: 5px ridge white;
  width: 100%;
}

@media only screen and (min-width: 400px) {
  .title {
    font-size: 50px;
  }
}

@media only screen and (max-width: 400px) {
  .title {
    padding-top: 5%;
  }

  .width {
    width: 90%;
  }

  p {
    font-size: 20px;
  }

  .meme {
    padding: 0.5em;
  }

  .meme-section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media only screen and (min-width: 400px) {
  .ca {
    font-size: 10px;
  }


}

@media only screen and (min-width: 550px) {
  .hide {
    display: none;
  }
}

@media only screen and (max-width: 500px) {
  
.buy-button {
 
  font-size: 20px;
 
}
}

@media only screen and (max-width:551px) {
  .hide2 {
    display: none;
  }
}

@media only screen and (min-width: 620px) {
  .ca {
    font-size: 15px;
  }

  .check {
    width: 100px;
  }

  .checkbox-section {
    margin-bottom: 40px;
  }

  .text {
    margin-bottom: 50px;
  }
}

@media only screen and (max-width: 619px) {
  .view {
    height: min-content;
  }
}

@media only screen and (min-width: 620px) {
  p {
    font-size: 30px;
  }

  /* .socials-section {
    gap: 20%;
  } */

  .logo {
    width: 60%;
    max-width: 500px;
  }

  .meme {
    margin-bottom: 8%;
  }

  .title {
    font-size: 70px;
  }

  .ca {
    margin: 0px;
  }
}

@media only screen and (min-width: 900px) {
  .title {
    font-size: 100px;
  }

  .socials {
    margin-bottom: 15%;
    width: 90px;
  }

  .tiktok {
    width: 110px;
  }
}

@media only screen and (min-width: 1200px) {
  .ca {
    font-size: 20px;
  }
}
</style>
